var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 31.0776 0.496524 34.0392 1.41384 36.8091L9.1415 30.0474C9.34243 29.8716 9.60532 29.7835 9.87161 29.8026C10.1379 29.8217 10.3855 29.9465 10.5593 30.1492L18.2763 39.1524L40.9582 17.7306L34.3751 17.5426C33.8231 17.5268 33.3883 17.0665 33.4041 16.5144C33.4199 15.9623 33.8802 15.5276 34.4322 15.5434L43.4286 15.8004C43.9806 15.8162 44.4154 16.2765 44.3996 16.8286L44.1426 25.8249C44.1268 26.377 43.6665 26.8117 43.1144 26.7959C42.5623 26.7802 42.1276 26.3198 42.1434 25.7678L42.3315 19.1847L18.8866 41.327C18.6877 41.5149 18.4206 41.613 18.1474 41.5986C17.8742 41.5842 17.6188 41.4585 17.4407 41.2508L9.69822 32.2178L2.16333 38.8109C6.39298 48.9073 16.3682 56 28 56Z",
    fill: "#7B61FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.3840981ee145f4eec3002244aa8d1e7b.svg";
export { ForwardRef as ReactComponent };